/**
 * Product Carousel — scroll arrows, tab filters, overflow detection
 * Supports two layouts: promo_card (Promotions) and tab_filters (Hair)
 */
(function () {
  'use strict';

  document.querySelectorAll('[data-product-carousel]').forEach(initCarousel);

  function initCarousel(section) {
    var track = section.querySelector('[data-carousel-track]');
    var prevBtn = section.querySelector('[data-carousel-prev]');
    var nextBtn = section.querySelector('[data-carousel-next]');
    var tabs = section.querySelectorAll('[data-filter]');
    var items = section.querySelectorAll('.product-carousel__item');

    if (!track) return;

    /* ── Arrow visibility based on overflow ── */
    function updateArrows() {
      if (!prevBtn || !nextBtn) return;
      var scrollLeft = Math.round(track.scrollLeft);
      var maxScroll = track.scrollWidth - track.clientWidth;

      prevBtn.classList.toggle('is-hidden', scrollLeft <= 2);
      nextBtn.classList.toggle('is-hidden', scrollLeft >= maxScroll - 2);
    }

    /* ── Scroll by one card width ── */
    function scrollBy(direction) {
      var firstCard = track.querySelector('.product-carousel__item');
      if (!firstCard) return;
      var cardWidth = firstCard.offsetWidth + 16; // gap = 1rem = 16px
      var amount = direction === 'left' ? -cardWidth : cardWidth;
      track.scrollBy({ left: amount, behavior: 'smooth' });
    }

    /* ── Arrow click handlers ── */
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollBy('left');
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollBy('right');
      });
    }

    /* ── Listen for scroll to update arrow state ── */
    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);

    // Initial check (after layout settles)
    requestAnimationFrame(function () {
      updateArrows();
    });

    /* ── Tab filter logic — ogni tab mostra il proprio gruppo (la sua collezione) ── */
    function applyFilter(filterValue) {
      items.forEach(function (item) {
        var group = item.getAttribute('data-filter-group') || 'all';
        if (group === filterValue) item.classList.remove('pc-hide');
        else item.classList.add('pc-hide');
      });
      track.scrollLeft = 0;
      requestAnimationFrame(updateArrows);
    }
    if (tabs.length > 0 && items.length > 0) {
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) { t.classList.remove('is-active'); });
          this.classList.add('is-active');
          applyFilter(this.getAttribute('data-filter'));
        });
      });
      // Stato iniziale: mostra solo il gruppo del tab attivo (Tutti).
      var activeTab = section.querySelector('[data-filter].is-active') || tabs[0];
      if (activeTab) applyFilter(activeTab.getAttribute('data-filter'));
    }

    /* ── Mouse drag scrolling (desktop UX) ── */
    var isDown = false;
    var startX = 0;
    var scrollLeft = 0;

    track.addEventListener('mousedown', function (e) {
      isDown = true;
      track.classList.add('is-dragging');
      startX = e.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;
    });

    track.addEventListener('mouseleave', endDrag);
    track.addEventListener('mouseup', endDrag);

    function endDrag() {
      isDown = false;
      track.classList.remove('is-dragging');
    }

    track.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - track.offsetLeft;
      var walk = (x - startX) * 1.5;
      track.scrollLeft = scrollLeft - walk;
    });
  }
})();
